import styled from 'styled-components';

export const StyledAudioPlayer = styled('audio')`
	cursor: pointer;
	position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    max-width: 100%;
    max-height: 100%;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/AudioPlayer/styles.ts